<script>

    import { toast } from 'bulma-toast'

    import QuotationsService from '../$services/quotations.service'

    import Form from '../$components/form.svelte'
    import Button from '../$components/button.svelte'
    import Input from '../$components/input.text.svelte'

    let quotations = []
    let loading = false
    let data = {
        pickup: { zipcode: 72000 },
        delivery: { zipcode: null },
        package: {
            width: 10,
            height: 10,
            length: 10,
            weight: 1,
            value: 0,
        }
    }

    async function getQuotations() {

        quotations = []

        loading = true
        const resp = await QuotationsService.getQuotations(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        quotations = resp.data

        console.log({quotations})
    }

</script>

<Form on:submit={ getQuotations } {loading}>
    <div class="columns">
        <div class="column">
            <Input bind:value={ data.delivery.zipcode } label="Código Postal" icon="search" placeholder="Ingrese código postal de destino" />
        </div>
    </div>
    <div class="items-end">
        <Button type="submit" color="primary" text="Consultar" icon="search" />
    </div>
</Form>

{#if quotations && quotations.length}
    <div class="table-container">
        <table class="table is-fullwidth">
            <thead>
                <tr>
                    <th>Proveedor</th>
                    <th>Servicio</th>
                    <th>Zona extendida</th>
                    <th>Ocurre</th>
                </tr>
            </thead>
            <tbody>
                {#each quotations as quotation}
                    <tr>
                        <td>{ quotation.provider }</td>
                        <td>{ quotation.service }</td>
                        <td>{ quotation.isCoverageCost? 'Si' : 'No' }</td>
                        <td>{ quotation.isDeliveryHome? 'No' : 'Si' }</td>
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
{/if}